import FooterBlock from './FooterBlock'

export default FooterBlock
